var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBellOffFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.15l-9.8-9.8c.333-.25.692-.48 1.075-.688A4.836 4.836 0 0110.5 4.2v-.7c0-.417.146-.77.438-1.062A1.444 1.444 0 0112 2c.417 0 .77.146 1.062.438.292.291.438.645.438 1.062v.7a5.927 5.927 0 013.225 2.087C17.575 7.346 18 8.583 18 10v5.15zM4 19v-2h2v-7a6.074 6.074 0 01.1-1.1L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4-3.65-3.6H4zm8 3c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0110 20h4a1.93 1.93 0 01-.587 1.413A1.928 1.928 0 0112 22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellOffFill);
export default __webpack_public_path__ + "30325d55164b90f8c7b5770bc1e55c98.svg";
export { ForwardRef as ReactComponent };